import { useQueryClient } from '@tanstack/react-query';
import { ALL_PROPERTIES_BASE_QUERY_KEY } from 'components/domain/property/useFetchAllProperties';
import { Property } from 'models/Properties';
import useAppUser from 'hooks/useAppUser';
import { ALL_PROPERTIES_SETTINGS_QUERY_OPERATION_NAME } from './usePropertySettingsInitData';

const usePropertySettingsQuery = () => {
  const { agencyUid } = useAppUser();
  const queryClient = useQueryClient();

  const queryKey = [
    ALL_PROPERTIES_BASE_QUERY_KEY,
    ALL_PROPERTIES_SETTINGS_QUERY_OPERATION_NAME,
    agencyUid,
  ];

  const setQueryPropertyData = (
    updater: (oldData: Property[]) => Property[],
  ) => {
    queryClient.setQueriesData<Property[]>(queryKey, (oldData) => {
      if (!oldData || oldData?.length === 0) {
        return oldData;
      }

      return updater(oldData);
    });
  };

  const invalidateQuery = () => {
    queryClient.invalidateQueries(queryKey);
  };

  return {
    queryKey,
    setQueryPropertyData,
    invalidateQuery,
  };
};

export default usePropertySettingsQuery;
